import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {ErrorMessageWrapper} from "@/components/error";
import {ErrorIcon} from "@/components/icons";
import {apiConfig} from "@/store";

export const ErrorMessage: React.FC= observer(() => {
    const {errorResponse, setErrorResponse} = apiConfig
    useEffect(()=> {
        const timer = setTimeout(() => {
            setErrorResponse(null);
        }, 5000);
        return () => clearTimeout(timer);
    }, [errorResponse])
    return (
        <ErrorMessageWrapper $enabled={!!errorResponse}>
            <div style={{display: !!errorResponse ? 'flex': 'none'}}> <ErrorIcon /></div>
            <div style={{width: 200}}>
                {!!errorResponse && errorResponse.detail}
            </div>
            <div/>
        </ErrorMessageWrapper>
    )
})